import { module as m } from 'modujs';
import gsap from 'gsap';
import {StoreSingleton} from "../../singletons/store";
import Swiper, { Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';

export default class extends m {
    constructor(m) {
        super(m);

        // VAR
        this.current = this.$('item')[0];
        this.previousIllustration = null;
        this.currentIllustration = this.el.querySelector('.' + this.current.dataset.id);

        // EVENTS
        this.events = {
            click: {
                item: '_selectCurrent'
            }
        }
    }

    init() {
        if(StoreSingleton.isMobile) {
            this.swiper = new Swiper(this.$('swiper')[0], {
                slidesPerView: 1,
                autoHeight: true,
                pagination: {
                    el: '.swiper-pagination',
                },
                modules: [Pagination],
            });

            this.swiper.on('slideChange', function (e) {
                const _currentMedia = this.el.querySelectorAll('.swiper-slide')[e.activeIndex].querySelector('.media')
                const _previousMedia = this.el.querySelectorAll('.swiper-slide')[e.previousIndex].querySelector('.media');

                if(_currentMedia.classList.contains('is-video'))
                    _currentMedia.play();

                if(_previousMedia.classList.contains('is-video'))
                    _previousMedia.pause();
            });
        }
    }

    /**
     * SELECT CURRENT
     * @private
     */
    _selectCurrent(e) {

        // CURRENT
        this.previous = this.current;
        this.current.classList.remove('current');
        this.current = e.currentTarget;
        this.current.classList.add('current');

        this.previousIllustration = this.currentIllustration;
        this.currentIllustration = this.el.querySelector('.' + this.current.dataset.id);

        if(this.previousIllustration.classList.contains('is-video'))
            this.previousIllustration.pause();

        // ILLUSTRATION
        const _tl = gsap.timeline({
            onComplete: () => {
                if(this.currentIllustration.classList.contains('is-video'))
                    this.currentIllustration.play();
            }
        });
        _tl.to(this.previousIllustration, {
            duration: 0.6,
            alpha: 0,
            ease: 'power4.out'
        });
        _tl.to(this.currentIllustration, {
            duration: 0.6,
            alpha: 1,
            ease: 'power4.out'
        }, 0.2);
    }
}
